<ng-component *ngComponentOutlet="anfrageLiveSharingComponent"></ng-component>
<div class="h-100 d-flex overflow-y-hidden overflow-x-hidden">
        <prozess-navigation
            id="resizableLeft"
            class="navigation"
            [ngClass]="{ 'collapsed': !showProzessNavigation }"
            >
            <div>
                <app-navigation-item
                    *ngFor="let navItem of navItemList"
                    [name]="navItem.name"
                    [kurzbeschreibung]="navItem.kurzbeschreibung"
                    [href]="getLink(navItem)"
                    [isValid]="getStatusFor(navItem.id) == 1"
                    [isActive]="isCurrentRoute(navItem.abschnitt)"
                    [showValidationStatus]="false"
                    [reportStatusIcon]="iconReportStatus(navItem.id)"
                    [reportStatusIconTitle]="iconReportStatusTitle(navItem.id) | translate"
                    [hasChildren]="navItem.childAbschnitte && navItem.childAbschnitte.length > 0"
                    [hasNephews]="true"
                    [isExpanded]="isParentOpen(navItem.abschnitt)"
                    (click)="onAppNavigationItemClick()"
                    >
        
                    <div group *ngIf="navItem.childAbschnitte && navItem.childAbschnitte.length > 0 && isParentOpen(navItem.abschnitt)">
                        <app-navigation-item
                            *ngFor="let navItemChild of navItem.children"
                            [name]="navItemChild.name"
                            [kurzbeschreibung]="navItemChild.kurzbeschreibung"
                            [href]="navItemChild.link"
                            [isValid]="getStatusFor(navItemChild.id) == 1"
                            [showValidationStatus]="showValidationStatus(navItem.id)"
                            [isSubItem]="true"
                            [isActive]="isCurrentRoute(navItem.abschnitt, navItemChild.abschnitt)"
                            [formIcon]="navItemChild.icon"
                            (click)="onAppNavigationItemClick()"
                            >
                        </app-navigation-item>
                        <app-navigation-item
                        *ngIf="showAbsenden"
                        [name]="GetAbsendenText"
                        href="./dataprotection"
                        [isValid]="getStatusFor('dataprotection') == 1"
                        [showValidationStatus]="showValidationStatus(navItem.id)"
                        [isSubItem]="true"
                        [isActive]="isDataprotectionRoute()"
                        [formIcon]="'send'"
                        (click)="onAppNavigationItemClick()"
                        >
                        </app-navigation-item>
                    </div>
                </app-navigation-item>
            </div>
            <div (mousedown)="draggableSidebar.onMouseDown($event, 'resizableLeft')" class="resize-bar right" [ngClass]="{'hidden' : ! showProzessNavigation}"></div>
        </prozess-navigation>

    <main class="content" id="main-content">
        <div id="topPosition"></div>
        <router-outlet></router-outlet>
    </main>

    <ng-component *ngComponentOutlet="detailSidepaneComponent"></ng-component>
</div>